import { useQueryClient } from "@tanstack/react-query";
import type { ConfirmEmailMfaEnrollmentRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useConfirmEmailMfaEnrollment() {
  const queryClient = useQueryClient();

  return useApiMutation("post", "/auth/mfa/email/confirm", {
    notify: { error: false },
    invalidate: () => {
      queryClient.invalidateQueries({ queryKey: ["get", "/users/me"] });
    },
    mapVariables: (body: ConfirmEmailMfaEnrollmentRequestDto) => ({ body }),
  });
}
